


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-edit-0.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;

@Injectable()
export class MasterEdit0Effects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
  ) { }

  initValueService = (payload: any) => {
    const code = payload.code;
    if (typeof code === "undefined") {
      return of({})
        ;
    }
    if (payload.parentCtx && payload.parentCtx.roleName) {
      return this.store.select(fromStore.selectRoleValue, {
        ...payload.parentCtx,
        code
      });
    } else {

      return of({})
        ;
    }
  };

  initValue$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.initValueAction),
      switchMap(payload => {
        return this.initValueService(payload).pipe(
          map(
            result =>
              fromMaster.initValueSuccessAction({
                ...payload,

                result

              })
          ),
          catchError(error =>
            of(fromMaster.initValueFailAction({ ...payload, error }))
          )
        );
      }))
  );

  fetchresidentePossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'residente'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchestrangeiroPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'estrangeiro'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchddiPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'ddi'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchclientePossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'cliente'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchstatusPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'status'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchportuguesPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'portugues'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchinglesPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'ingles'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );










}


